import { type AggregationFn } from "@tanstack/react-table";
import { format, isValid, parseISO } from "date-fns";

export const maxDate: AggregationFn<unknown> = (columnId, leafRows) => {
	let latest: Date | undefined;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (typeof value !== "string") {
			return;
		}

		try {
			const date = parseISO(value);
			if (!latest || date > latest) {
				latest = date;
			}
		} catch (e) {
			return;
		}
	});
	if (!latest || !isValid(latest)) {
		return "";
	}
	return format(latest, "MM-dd-yyyy");
};
